export const BASE_INBOX_PATH = 'inbox';